import "./Breadcrumbs.css";
import React from "react";
import { Link } from "react-router";
import { connect } from "react-redux";

const breadcrumbsSchema = {
  agencies: {
    stateName: "agency",
    name: "Agencje",
    children: {
      add: {
        name: "Nowa agencja"
      },
      edit: {
        isVisible: false,
        children: {
          uid: {
            name: "dynamic",
            key: ["name"]
          }
        }
      }
    }
  },
  offers: {
    stateName: "offer",
    name: "Oferty",
    children: {
      add: {
        name: "Nowa oferta"
      },
      edit: {
        isVisible: false,
        children: {
          uid: {
            name: "dynamic",
            key: ["uid"]
          }
        }
      }
    }
  },
  applications: {
    stateName: "application",
    name: "Aplikacje",
    children: {
      edit: {
        isVisible: false,
        children: {
          uid: {
            name: "dynamic",
            key: ["uid"]
          }
        }
      }
    }
  },
  articles: {
    stateName: "article",
    name: "Artykuły",
    children: {
      edit: {
        isVisible: false,
        children: {
          uid: {
            name: "dynamic",
            key: ["uid"]
          }
        }
      }
    }
  },
  admins: {
    stateName: "admin",
    name: "Administratorzy",
    children: {
      add: {
        name: "Nowy administrator"
      },
      edit: {
        isVisible: false,
        children: {
          uid: {
            name: "dynamic",
            key: ["email"]
          }
        }
      }
    }
  }
};

export function getObject(object, element) {
  if (object == undefined) {
    return breadcrumbsSchema[element];
  } else {
    let el = object.children[element];
    if (el !== undefined) {
      return el;
    } else {
      return object.children["uid"];
    }
  }
}

class Breadcrumbs extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { location, state, appPath } = this.props;

    let names = [];
    let breadcrumbs = [];
    let path = location.pathname;

    if (path.indexOf(appPath) == 0) {
      path = path.slice(appPath.length);
    }
    const bcmbs = path.split("/");
    bcmbs.shift();

    let obj = undefined;
    for (let i = 0; i < bcmbs.length; i++) {
      obj = getObject(obj, bcmbs[i]);
      if (obj == undefined) {
        continue;
      }
      if (!obj.stateName && i === 0) {
        continue;
      }
      names[i] = obj.stateName;
      let name = obj.name;
      let path = appPath;

      for (let j = 0; j <= i; j++) {
        path += "/" + bcmbs[j];
      }

      if (name === "dynamic") {
        if (state[names[0]] && state[names[0]].map) {
          name = "";
          const self = this;
          obj.key.forEach(function(item) {
            let word = undefined;
            word = state[names[0]].getIn(["map", bcmbs[i], item]);
            if (word) {
              name += word + " ";
            }
          });
          if (name === "") {
            name = <i className="fa fa-spin fa-circle-o-notch" />;
          }
        } else {
          name = <i className="fa fa-spin fa-circle-o-notch" />;
        }
      }

      let bc = {
        name: name,
        path: path,
        depth: i,
        isVisible: obj.isVisible,
        noLink: obj.noLink
      };
      if (obj.isVisible !== false) {
        breadcrumbs.push(bc);
      }
    }

    const depth = breadcrumbs.length;
    return (
      <ul className="breadcrumbs-list">
        {breadcrumbs.length > 1 &&
          breadcrumbs.map((item, index) => (
            <div className="breadcrumb-wrapper" key={item.path}>
              {index >= 0 &&
              item.isVisible !== false && (
                <li key={index}>
                  {item.path && (
                    <div className="breadcrumb-separator">
                      {index <= depth && index >= 1 && "/"}
                    </div>
                  )}
                  {index !== depth - 1 &&
                  !item.noLink && (
                    <Link
                      activeClassName="breadcrumb-active"
                      to={item.path || ""}
                    >
                      {item.name}
                    </Link>
                  )}
                  {(index === depth - 1 || item.noLink) && item.name}
                </li>
              )}
            </div>
          ))}
      </ul>
    );
  }
}

export default connect(
  state => ({
    state: state,
    appPath: state.config.appPath
  }),
  {}
)(Breadcrumbs);



// WEBPACK FOOTER //
// ./src/browser/components/Breadcrumbs/Breadcrumbs.js